import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import StarRatingClass from './StarRating';
import HeartRatingClass from './HeartRating';
import ThumbsUpDownRatingClass from './ThumbsUpDownRating';
import PillRatingClass from './PillRating';
import BarRating from './BarRating';
import MovieRating from './MovieRating';
import SquareNumber from './SquareNumber';
import HalfStar from './HalfStar';

const RatingClassContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Rating' parent='Bonus Ui' title='Rating' />
      <Row>
        <BarRating />
        <MovieRating />
        <SquareNumber />
        <PillRatingClass />
        <StarRatingClass />
        <HalfStar />
        <ThumbsUpDownRatingClass />
        <HeartRatingClass />
      </Row>
    </Container>
  );
};

export default RatingClassContainer;
